// Immediate execution to verify script loading
console.log('=== Featured Admiral Script Loading ===');
console.log('Script loaded at:', new Date().toISOString());
console.log('Document Ready State:', document.readyState);

// Function to initialize the component
function initializeFeaturedAdmiral() {
  console.log('=== Initializing Featured Admiral ===');
  console.log('Initialization time:', new Date().toISOString());
  
  // Buscar el selector específico de Base
  const baseSelector = document.querySelector('.bcpo-default select[data-option="option3"]');
  console.log('=== Base Selector Status ===');
  console.log('Found:', !!baseSelector);
  
  if (baseSelector) {
    // Obtener el contenedor completo
    const selectorWrapper = baseSelector.closest('.selector-wrapper');
    console.log('=== Selector Wrapper Details ===');
    console.log('Wrapper found:', !!selectorWrapper);
    
    if (selectorWrapper) {
      // Obtener el label y sus elementos
      const label = selectorWrapper.querySelector('.bcpo-label');
      const titleSpan = label?.querySelector('.bcpo-title');
      const valueSpan = label?.querySelector('.bcpo-value');
      
      console.log('=== Label Details ===');
      console.log('Label found:', !!label);
      console.log('Title span found:', !!titleSpan);
      console.log('Value span found:', !!valueSpan);
      
      if (titleSpan && valueSpan) {
        console.log('Current title:', titleSpan.textContent);
        console.log('Current value:', valueSpan.textContent);
      }
    }

    // Detalles del select
    console.log('=== Select Element Details ===');
    console.log('Current value:', baseSelector.value);
    console.log('Selected option:', baseSelector.options[baseSelector.selectedIndex]?.text);
    console.log('All options:', Array.from(baseSelector.options).map(opt => ({
      value: opt.value,
      text: opt.text,
      selected: opt.selected
    })));
    
    // Agregar listener para cambios
    baseSelector.addEventListener('change', (event) => {
      const select = event.target;
      const selectedOption = select.options[select.selectedIndex];
      const wrapper = select.closest('.selector-wrapper');
      const valueSpan = wrapper?.querySelector('.bcpo-value');
      
      console.log('=== Base Selection Changed ===');
      console.log('Previous Value:', select.dataset.previousValue || 'none');
      console.log('New Value:', selectedOption.value);
      console.log('New Text:', selectedOption.text);
      console.log('Value Span Updated:', valueSpan?.textContent);
      
      // Store current value for next change
      select.dataset.previousValue = selectedOption.value;
    });
  }
}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
  console.log('Document still loading, waiting for DOMContentLoaded...');
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOM Content Loaded event fired');
    initializeFeaturedAdmiral();
  });
} else {
  console.log('Document already loaded, initializing immediately...');
  initializeFeaturedAdmiral();
}

// Backup initialization
window.addEventListener('load', () => {
  console.log('Window load event fired');
  if (!window.featuredAdmiralInitialized) {
    console.log('Initializing from window load event');
    initializeFeaturedAdmiral();
    window.featuredAdmiralInitialized = true;
  }
}); 


document.querySelectorAll('a[href^="#ready-to-ship"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        const offset = 100;
        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

document.addEventListener('DOMContentLoaded', function () {
function getCurrentSelections() {
  return {
    cLeatherColor: $('div#bcpo-select-option-1 input:checked').val() || '',
    cWoodColor: $('.selector-wrapper.bcpo-simple.bcpo-images input:checked').eq(1).val() || '',
    cBase: $('div#bcpo-select-option-2 input:checked').val() || '',
    cSize: $('div#bcpo-select-option-0 input:checked').val() || ''
  };
}

function updateButtonState() {
  const { cLeatherColor, cWoodColor, cBase, cSize } = getCurrentSelections();
  const $submitBtn = $('.match-found-link');

  // Check if data is available
  if (!window.quickShipProductOptions || !window.currentProductBaseName) {
    console.log('❌ Featured Admiral: Ready-to-ship data not loaded yet. Available:', {
      quickShipProductOptions: !!window.quickShipProductOptions,
      currentProductBaseName: window.currentProductBaseName,
      currentProductTitle: window.currentProductTitle
    });
    return;
  }

  // Filter products to only match the current product's base name (Admiral, Mayfair, etc.)
  const currentBaseName = window.currentProductBaseName || 'Admiral'; // Default to Admiral for backwards compatibility
  const filteredOptions = window.quickShipProductOptions.filter(option => 
    option.base_product_name === currentBaseName || option.title.includes(currentBaseName)
  );

  const match = filteredOptions.find(option =>
    cLeatherColor.includes(option.leather_color) &&
    option.wood_color === cWoodColor &&
    option.base === cBase &&
    option.size === cSize
  );

  if (match && match.inventory > 0) {
    $submitBtn.removeClass('sold-out').prop('disabled', false).text('Add to Cart');
    $submitBtn.attr('href', `/cart/add?id=`+match.variant_id+`&quantity=1`);
    jQuery('.product__info-wrapper').addClass('match-found');
    jQuery('.featured-admiral').addClass('match-found');
  } else if (match && match.inventory <= 0) {
    $submitBtn.addClass('sold-out').prop('disabled', true).text('Sold Out');
    jQuery('.product__info-wrapper').removeClass('match-found');
    jQuery('.featured-admiral').removeClass('match-found');
  } else {
    $submitBtn.removeClass('sold-out').prop('disabled', false).text('Add to Cart');
    jQuery('.product__info-wrapper').removeClass('match-found');
    jQuery('.featured-admiral').removeClass('match-found');
  }
}

// Start checking after a short delay to ensure data is loaded
setTimeout(() => {
  updateButtonState(); // Check immediately after delay
  setInterval(updateButtonState, 1000); // Then check every second
}, 500);

});


document.addEventListener("DOMContentLoaded", function () {
  const admiralButton = document.querySelector('[href="#product-form"]');
  const admiralTargetSection = document.querySelector('.featured-admiral-section');

  if (admiralButton && admiralTargetSection) {
    admiralButton.addEventListener("click", function (e) {
      e.preventDefault(); // Prevent default jump
      admiralTargetSection.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    });
  }
});
